import TipTapEditorImproved from 'offers/details/components/TipTapEditorImproved';
import React from 'react';

export const OfferIntroduction = ({
  description,
  setDescription,
  isAIDescriptionGenerated,
  setIsAIDescriptionGenerated,
}) => {
  return (
    <div className='grid grid-cols-1 gap-4'>
      <TipTapEditorImproved
        content={description}
        setContent={setDescription}
        isAIDescriptionGenerated={isAIDescriptionGenerated}
        setIsAIDescriptionGenerated={setIsAIDescriptionGenerated}
      />
    </div>
  );
};
